import Login from '@/cms/components/Login';
import Main from '@/cms/components/Main';
import store from '@/store';
export default 
  [
    {
      path: '/cms',
      name: "main",
      component: Main,
      /*
      beforeEnter:(to,from,next) =>  {
        console.log (store.getters.isLoggedIn)
        if (store.getters.isLoggedIn == false) {
          next("/cms/login");
        }  
      }*/
      meta: {
        cmsLogin:true,
      }
    },
    {
      path: '/cms/login',
      name: "login",
      component: Login
    }
  ]
